import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
export default mutatorAction('SET_IS_EXPORT_MAILBOX_REQUEST_MADE', function (isExportMailboxRequestMade) {
    getStore().isExportMailboxRequestMade = isExportMailboxRequestMade;
});
//# sourceMappingURL=setIsExportMailboxRequestMade.js.map